module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-actions"
  }, [_c('button', {
    staticClass: "button is-success",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.itemAction('resolve', _vm.rowData, _vm.rowIndex)
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isLoading2
    },
    on: {
      "click": function($event) {
        _vm.itemAction('mark', _vm.rowData, _vm.rowIndex)
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('button', {
    staticClass: "button is-danger",
    class: {
      'is-loading': _vm.isLoading3
    },
    on: {
      "click": function($event) {
        _vm.itemAction('delete', _vm.rowData, _vm.rowIndex)
      }
    }
  }, [_vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6e09818"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TransActions.vue
// module id = 255
// module chunks = 1